import Blue from "~/core";

new Blue({
	name: 'Search Filters Accordions',
	selector: ".search-filters__drawer",
	setup(container) {
		const items = [...container.querySelectorAll(".search-filters__set")];
		const groups = [...container.querySelectorAll(".search-filters__item-group")];
		let toggleArray = []; // used to loop through and close all when needed

		// init all accordions using toggle plugin
		[...items, ...groups].forEach(cont => {
			let isToggleable = !!cont.querySelector(".search-filters__set-trigger") || !!cont.querySelector(".search-filters__item-group-trigger");
			if (isToggleable) {
				const trigger = cont.querySelector(".search-filters__set-trigger") || cont.querySelector(".search-filters__item-group-trigger");
				const content = cont.querySelector(".search-filters__set-options") || cont.querySelector(".search-filters__item-group-subset");
				const config = {
					container: cont,
					trigger,
					content
				}
				let t = new this.$toggle(config);
				toggleArray.push(t);
			}
		});
	}
});

new Blue({
	name: 'Search Filters Checkbox Actions',
	selector: ".search-filters__set-options",
	setup(container) {
		const checkboxAllToggles = [...container.querySelectorAll(".search-filters__item-input-all")];
		
		const setCheckValues = (checkbox, childCheckboxes) => {
			let someChecked = childCheckboxes.some(cc => cc.checked);
			let allChecked = childCheckboxes.every(cc => cc.checked);
			(!allChecked && someChecked) && checkbox.classList.add("partial-selection");
			(allChecked || !someChecked) &&	checkbox.classList.remove("partial-selection");
			checkbox.checked = allChecked;
		}

		const toggleCheckAll = (checkbox, childCheckboxes) => {
			if (!checkbox.checked) {
				childCheckboxes.forEach(cc => {cc.checked = false});
			} else {
				childCheckboxes.forEach(cc => {cc.checked = true});
			}
			if (!checkbox.closest(".search-filters__item-group-top")) {
				childCheckboxes.forEach(cc => {
					if (!!cc.closest(".search-filters__item-group-top")) cc.classList.remove("partial-selection")
				});
			}
			checkbox.classList.remove("partial-selection");
		}

		checkboxAllToggles.forEach(c => {
			let parent = !!c.closest(".search-filters__item-group-top") ? 
				c.closest(".search-filters__item-group") :
				c.closest(".search-filters__item");
			let childCheckboxes = !c.closest(".search-filters__item-group-top") ?
				[...parent.querySelectorAll(".search-filters__item-group input[type=checkbox]:not([disabled])")] :
				[...parent.querySelectorAll("input[type=checkbox]:not(.search-filters__item-input-all):not([disabled])")];
			setCheckValues(c, childCheckboxes);
			this.$addEvents(c, "input", () => {toggleCheckAll(c, childCheckboxes)});
			childCheckboxes.forEach(cc => {
				this.$addEvents(cc, "change", () => {setCheckValues(c, childCheckboxes)});
			});
		});
	}
});

new Blue({
	name: 'Search Filters Mobile Behavior',
	selector: ".page-sidebar__mobile .search-filters",
	setup(container) {
		const form = container.querySelector(".search-filters__form");
		const searchTop = document.querySelector(".poops-top");
		const mobileTrigger = document.querySelector(".search-header__filter-toggle");
		const closeBtn = container.querySelector(".search-filters__mobile-header-close");
		const breakpoint = 769;
		
		this.$retach(form, {
			destination: !!searchTop ? searchTop : document.querySelector("main"), 
			mediaQuery: breakpoint,
			movedClass: 'is-moved',
			moveMethod: 'prepend', 
			wrapper: !!searchTop ? null : 'div',
			wrapperClass: !!searchTop ? null :  'container',
		});

		const openMobileFilters = () => {
			container.classList.add("is-open");
			//console.log('scroll lock removed')
			//this.$scrollLock.lock(document.body);
		}
		
		const closeMobileFilters = () => {
			container.classList.remove("is-open");
			//this.$scrollLock.unlock(document.body);
		}

		this.$addEvents(mobileTrigger, "click.prevent", openMobileFilters);
		this.$addEvents(closeBtn, "click.prevent", closeMobileFilters);
	}
});